import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {LeftpanelComponent} from '../../leftpanel/leftpanel.component';
import {en} from 'cronstrue/dist/i18n/locales/en';

@Component({
    selector: 'app-entity',
    templateUrl: './entity.component.html',
    styleUrls: ['./entity.component.scss']
})
export class EntityComponent implements OnInit {

    @Input() entity: any;
    @Input() partner = localStorage.getItem('partner');
    @Input() account = localStorage.getItem('account');
    @Input() showActionText = true;
    @Input() depth = 0;
    @Output() dependencies: EventEmitter<any> = new EventEmitter<any>();
    @Output() usages: EventEmitter<any> = new EventEmitter<any>();
    @Output() isEditAPIDefClicked: EventEmitter<any> = new EventEmitter<any>();
    @Input() isApiDiscovery = false;
    @Output() isEntityMgmtClicked: EventEmitter<any> = new EventEmitter<any>();
    @Output() isDocTestClicked: EventEmitter<any> = new EventEmitter<any>();
    @Output() isMethodClicked: EventEmitter<any> = new EventEmitter<any>();

    constructor(public platform: LeftpanelComponent) {
    }

    ngOnInit() {
    }

    getMethodClass(method) {
        switch (method) {
            case 'GET':
                return 'get';
            case 'PUT':
                return 'put';
            case 'POST':
                return 'post';
            case 'DELETE':
                return 'delete';
            case 'PATCH':
                return 'patch';
        }
    }

    getMethodName(method, entityname) {
        return method.toLowerCase() + entityname;
    }

    findDependencies(entity, key) {
        this.dependencies.emit({entity: entity, key: key});
    }

    findUsages(entity, key) {
        this.usages.emit({entity: entity, key: key});
    }
}
